<template>
    <!-- Fixed Bottom Actions -->
    <div class="fixed-bottom-actions">
        <div class="action-buttons-wrapper">
            <button
                v-if="showManage && (product.sales_type === 'fixed' || (product.sales_type !== 'fixed' && product.paused))"
                class="btn btn-manage" :title="$t('action.manage')" @click.prevent="handleManageClick">
                ⚙️ {{ $t('action.manage') }}
            </button>
            <button disabled v-if="product.active_boost && product.active_boost.length > 0" class="btn btn-boost">
                {{ $t('ecommerce.product.boosted') }}
            </button>
            <button v-else-if="showBoost && product.is_active && product.user.id == authUser.id" class="btn btn-boost"
                :title="$t('action.boost')" @click.prevent="handleBoostClick">
                🚀 {{ $t('action.boost') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductManagementActions',
    props: {
        product: {
            type: Object,
            required: true
        },
        showManage: {
            type: Boolean,
            default: true,
        },
        showBoost: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        authUser: {
            get() {
                return this.$store.state.user;
            },
        },
    },
    emits: ['open-manage', 'open-boost'],
    methods: {
        handleManageClick() {
            this.$emit('open-manage');
        },
        handleBoostClickOld() {
            console.log('Boost button clicked');
            this.$emit('open-boost');
        },
        handleBoostClick() {
            this.$router.push({
                name: "BoostPlanManagement",
                params: {
                    id: this.product.id
                }
            });
        }
    }
};
</script>
